import { Grid, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { Image } from '@/src/components/atoms';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
  },
  imageWrapper: {
    maxWidth: 350,
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  content: {
    position: 'absolute',
    padding: theme.spacing(2),
    top: '50%',
    transform: 'translateY(-50%)',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      transform: 'none',
      padding: theme.spacing(0, 4),
    },
  },
}));

const EmptyState = props => {
  const {
    imageSrc = '/images/illustrations/empty-state.svg',
    imageSrcSet,
    reverse,
    className,
    title = 'Ooops... 🥺',
    subtitle = 'Nenhum resultado para ser exibido.',
    ButtonProps,
    ...rest
  } = props;

  const classes = useStyles();

  return (
    <Grid
      container
      justifyContent="center"
      className={clsx('empty-state', classes.root, className)}
      direction={reverse ? 'row-reverse' : 'row'}
      spacing={4}
      {...rest}>
      <Grid item xs={12} className={clsx('empty-state__image-wrapper', classes.imageWrapper)}>
        <Image
          src={imageSrc}
          srcSet={imageSrcSet || ''}
          alt="..."
          className={clsx('empty-state__image', classes.image)}
          lazy={false}
        />
      </Grid>
      <Grid item xs={12} className={clsx('empty-state__content', classes.content)}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="h4" align="center">
              {title}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" align="center">
              {subtitle}
            </Typography>
          </Grid>
          {ButtonProps && (
            <Grid item xs={12}>
              <center>
                <Button variant="outlined" size="large" color="primary" {...ButtonProps}>
                  Voltar
                </Button>
              </center>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

EmptyState.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * Side image
   */
  imageSrc: PropTypes.string,
  /**
   * Side image srcset
   */
  imageSrcSet: PropTypes.string,
  /**
   * Should show in reverse order
   */
  reverse: PropTypes.bool,
  /**
   * Title
   */
  title: PropTypes.string,
  /**
   * Subtitle
   */
  subtitle: PropTypes.string,
  /**
   * Button call to action props
   */
  ButtonProps: PropTypes.object,
};

export default EmptyState;
